import "$styles/index.css"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

import { initNav } from "./nav.js"
import { initGallery } from "./gallery.js"
import { initLightbox } from "./lightbox.js"
import { initContactForm } from "./contact-form.js"
import { initStockSearch } from "./stock_search.js"
import { initPackages } from "./packages.js"

const init = () => {
  initNav()
  initGallery()
  initLightbox()
  initContactForm()
  initStockSearch()
  initPackages()
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init)
} else {
  init()
}
